module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (248).1f86343d.jpg";